'use client';
import React from 'react';
import SpecificationTab from './SpecificationTab';
import { Box } from '@mui/material';
import cn from './style.module.scss';
type Props = {
  anchorId?: string;
};
export default function HomeSpecification(props: any) {
  const { t, anchorId } = props;
  return (
    <Box
      component={'section'}
      id={anchorId}
      className={cn.beachHomeSpecification}
      sx={{
        backgroundImage: `url(${props.beachHomeSpecificationBackground.url})`,
      }}
    >
      <Box component={'div'} className={cn.beachSpecificationInner}>
        <SpecificationTab
          t={t}
          specificationDesktopTheme={props.specificationDesktopTheme}
          specificationMobileTheme={props.specificationMobileTheme}
        />
      </Box>
    </Box>
  );
}
